import { gql } from 'graphql-request'

export const REMOVE_BOOKMARK = gql`
  mutation RemoveBookmark($id: Int!) {
    removeBookmark(id: $id) {
      id
    }
  }
`
